import { Routes } from '@angular/router';
import { RoutePath } from 'src/app/shared/enums/route-path.enum';
import { AuthGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: RoutePath.Landing },
  {
    path: RoutePath.Landing,
    loadComponent: () =>
      import('./pages/landing/landing.component').then(m => m.LandingComponent),
    canActivate: [AuthGuard],
  },
  {
    path: RoutePath.Privacy,
    loadComponent: () =>
      import('./pages/privacy/privacy.component').then(m => m.PrivacyComponent),
    canActivate: [AuthGuard],
  },
  {
    path: RoutePath.Terms,
    loadComponent: () =>
      import('./pages/terms/terms.component').then(m => m.TermsComponent),
    canActivate: [AuthGuard],
  },
  {
    path: RoutePath.Platform,
    loadComponent: () =>
      import('./platform/platform.component').then(m => m.PlatformComponent),
    loadChildren: () =>
      import('./platform/platform.routes').then(m => m.platformRoutes),
    canActivate: [AuthGuard],
  },
  {
    path: RoutePath.PlayerPopout,
    loadComponent: () =>
      import('./features/video-player/components/player-popout/player-popout.component').then(
        m => m.PlayerPopoutComponent,
      ),
  },
  { path: 'index.html', pathMatch: 'prefix', redirectTo: RoutePath.Landing },
  // Explicit route so the places that navigate here on purpose — the error
  // service and the admin/feature-flag guards — have a real target instead of
  // relying on the catch-all below.
  {
    path: RoutePath.Error404,
    loadComponent: () =>
      import('./pages/error404/error404.component').then(
        m => m.Error404Component,
      ),
  },
  {
    path: '**',
    loadComponent: () =>
      import('./pages/error404/error404.component').then(
        m => m.Error404Component,
      ),
  },
];
